import React, { useMemo, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import UserLayout from '../components/UserLayout.jsx'
import UISwitchChecker from '../../../global/practice/components/PracticeUISwitcher.jsx'

import apiUtils from '../../../global/utils/api.js'

const UserSelfServiceEnroll = () => {
  const [error, setError] = useState(false)

  const tokenset = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search)

    const token = urlParams.get('token')
    const accountHubToken = urlParams.get('AccountHubtoken')

    if (!token || !accountHubToken) {
      return null
    }

    return {
      token,
      accountHubToken,
    }
  }, [])

  useEffect(() => {
    if (!tokenset) {
      return
    }

    apiUtils.callAPI('/api/self-service/enroll', 'POST', tokenset).then(res => {
      if (!res.success) {
        setError(res.message)
        return
      }

      window.location = '/user/forward'
    })
  }, [tokenset])

  return (
    <UserLayout>
      <UISwitchChecker />
      <Helmet>
        <title>
          Finishing setting up your {window.brandingSettings.title} account
        </title>
      </Helmet>
      <div className="yt-container">
        <div className="yt-row center-horiz">
          <div
            className="form-container -skinny"
            style={{ marginTop: '64px', textAlign: 'center' }}
          >
            {tokenset ? (
              error ? (
                <p>
                  Something went wrong.
                  <br />
                  {error}
                </p>
              ) : (
                <React.Fragment>
                  <h3>
                    Finishing setting up your {window.brandingSettings.title}{' '}
                    account
                  </h3>
                  <p>Please don't leave this page.</p>
                  <span className="-self-service-spinner"></span>
                </React.Fragment>
              )
            ) : (
              <p>Invalid parameters.</p>
            )}
          </div>
        </div>
      </div>
    </UserLayout>
  )
}

export default UserSelfServiceEnroll
